/**
 * Created by gusenlin on 2018/5/3.
 */
import store from '@/vuex/index';

export function formatMoney(amount, places, symbol, thousand, decimal) {
  let baseCurrencycode = store.getters.getCompanyConfigurations.baseCurrency;

  places = !isNaN((places = Math.abs(places))) ? places : 2;
  symbol = symbol !== undefined ? symbol : baseCurrencycode;
  thousand = thousand || ',';
  decimal = decimal || '.';

  try {
    parseInt(amount);
  } catch (e) {
    return symbol + '0.01';
  }

  var number = amount,
    negative = number < 0 ? '-' : '',
    i = parseInt((number = Math.abs(+number || 0).toFixed(places)), 10) + '',
    j = (j = i.length) > 3 ? j % 3 : 0;

  return (
    symbol +
    ' ' +
    negative +
    (j ? i.substr(0, j) + thousand : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand) +
    (places
      ? decimal +
        Math.abs(number - i)
          .toFixed(places)
          .slice(2)
      : '')
  );
}
